import { createSelector } from "@reduxjs/toolkit";

export const selectSchedulesState = (state) => state.schedules;

export const selectSchedulesEntities = (state) => selectSchedulesState(state).entities;

export const selectHurdleNames = (state) => selectSchedulesState(state).hurdleNames;
